"use client";

import React from "react";

interface FormHeaderProps {
  displayName: string;
}

/**
 * Renders the form header with title and description
 */
export const FormHeader = React.memo(function FormHeader({ displayName }: FormHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
      <div className="flex-1">
        <h3 className="text-lg sm:text-xl font-semibold">Create {displayName}</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 hidden sm:block">
          Create a new {displayName.toLowerCase()}
        </p>
      </div>
    </div>
  );
});
